<template>
<div>
<div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
   </div>
   <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Uploading</div>
      <div id="admin-loader"></div>
   </div>
  <div class="" v-if="changed">
     <b-modal v-model="modalShow" ok-only centered centered class="text-center text-info">
      Image Uploaded
    </b-modal>
    <b-modal v-model="modalShow2" ok-only centered centered class="text-center text-danger">
      You have added maximum imagess. You can't add more images.
    </b-modal>
      
    <h2 class="m-auto text-info text-center pt-3 pb-1">Add images</h2>
     <div class="file-upload col-12 col-md-6 pb-3" style="margin-top: 30px;">
  <div class="image-upload-wrap" style="height: 80px;">
    <input class="file-upload-input" type='file' @change="fileSelect1" accept=".jpg, .jpeg" />
    <div class="drag-text">
      <h6 class="pt-3">Drag and drop or select Image</h6>
      <h6></h6>
    </div>
  </div>
  <div class="file-upload-content mx-auto text-center" :style="{display: visible1}">
    <img class="file-upload-image"  :src="imageUrl" alt="" />
     <el-button type="primary" class="mt-3 mx-auto text-center" @click="Upload()">Upload Image</el-button>
  </div>
</div >
   
    <h2 class="m-auto text-info text-center pt-3 pb-3">Image Gallery</h2>

    	<div class="row">
	
			<div class="col-sm-12">
				<div class="product-grid-list">
					<div class="row mt-30 justify-content-around" >
            
              <template v-for=" (img, i) in shops[0].gallery" >
						<div class=" col-12 col-sm-6 col-md-4 col-lg-3 " v-bind:key="i">
							<!-- product card -->
    <div class="product-item bg-light">
      <div class="card">

    <div class="block2-pic hov-img0">
            	<img  :src="img" alt="" >
							
						</div>
            <a @click="deleteImg(i)" class="btn btn-danger text-white">Delete Image</a>
      </div>
    </div>



						</div>
            </template>
					
					
					</div>
				</div>
			</div>
		</div>
    <!-- <div class="alert">
 
    </div>
  <div class="mt-5">
    <h3 class="text-center mt-3 mb-2 m-auto">Sample Offer Notification</h3>
     <div class="alert warning text-center mt-4">
  <span class="closebtn">&times;</span>  
  <strong>{{dis}}%</strong> Discount on {{cat}} items.
  </div>
  </div> -->
  </div>
  </div>
</template>

<script>
import AdminPanel from './Admin'
import ImageCompressor from 'image-compressor.js';
  import db from "../../config/FirebaseInit"
import firebase from "firebase/app"
export default {
  name: 'gallery',
  components: {
      AdminPanel
  },
  data(){
    return {
      cat:'',
      title:'',
      visible:'block',
      visible1:'none',
      imageUrl:'',
      image1:'',
      desc:'',
      service:{
        img:'',
        title:'',
        desc:''
      },
      modalShow: false,
      modalShow2: false,
      shops:[],
      loading:false,
       loading1:false,
      changed:false,
    }
  },
 created() {
   this.backToTop()
   this.loading = true
   this.changed = false
      db.collection('galleries').where('owner', '==', firebase.auth().currentUser.uid).get()
      .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
          'id': doc.id,
          'gallery':doc.data().gallery,
          
          
        }
        this.shops.push(data)
        this.loading = false
        this.changed = true
      })
    }) .catch(error => alert(error))
        
  },
  

  methods:{
     backToTop: function() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    },
    deleteImg(i){
      this.shops[0].gallery.splice(i,1)
       db.collection("galleries").doc(this.shops[0].id)
      .update({
      gallery: this.shops[0].gallery
      })
      .then(doc => {
      console.log('doc is', doc)
      })
      .catch(error => alert(error));
    },
    Upload (){
      this.loading1 =true
      this.changed = false
         if(this.shops[0].gallery.length < 10){
           this.shops[0].gallery.push(this.image1)
            console.log('uid',firebase.auth().currentUser.uid)
            db.collection("galleries").doc(this.shops[0].id)
            .update({
                gallery: this.shops[0].gallery
              
            })
             .then(doc => {
              console.log('doc is', doc)
             // this.modalShow = true
                this.image1 = ''
                this.imageUrl = ''
                      this.loading1 = false
                      this.changed = true
                      this.modalShow = true
            })
            .catch(error => alert(error))

         }else{
            this.loading1 = false
            this.changed = true
           this.modalShow2 = true
         }
        
      },

    fileSelect1(event) {
      console.log('event is', event)
      const files = event.target.files;
      let filename = files[0].name;
      if(files[0].type == 'image/png' || files[0].type == 'image/gif' || files[0].type == 'image/svg+xml' || files[0].type == 'image/tiff'){
       alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
      }else if(files[0].size > 5000200){
       alert("File " + files[0].name + " is too large!");
      }else{
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        this.visible = 'none'
        this.imageUrl = reader.result;
         this.visible1 = 'block'
      });
      reader.readAsDataURL(files[0]);
     //this.image = files[0];
     const imageCompressor = new ImageCompressor();
      imageCompressor.compress(files[0], {quality: .6, width:720, height:480})
      .then((result) => {
        // Handle the compressed image file.
        if(result.size >= 1000000){
          const imageCompressor = new ImageCompressor();
          imageCompressor.compress(result, {quality: .5})
          .then((result) => {
         
          const fileReader = new FileReader();

              // This fires after the blob has been read/loaded.
              fileReader.addEventListener('load', () => {
               
               this.image1 = fileReader.result
              
               console.log('image is',this.image1)
              });

              // Start reading the blob as text.
              fileReader.readAsDataURL(result);
          
          //console.log(filename) 
          console.log(result.size)
           console.log('image is',result)
      })
        }else{
           
          var fileReader = new FileReader();
          fileReader.addEventListener('load', () => {
               
               this.image1 = fileReader.result
              
               console.log('else image is',this.image1)
          });
          fileReader.readAsDataURL(result);
          //console.log(filename) 
          console.log('else',result.size)
           console.log('ekse image is',result)
        }
      })
      
      .catch((err) => {
        // Handle the error
        console.log("error is" + err)
      })
      }
    },

  }
}
</script>
<style>
@import url('~@/assets/main/css/styles.css');
@import url('~@/assets/admin/css/imgupload.css');
@import url('~@/assets/admin/css/admin-loader.css');
  .el-select .el-input {
    width: 110px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

  .alert {
    padding: 10px;
   
    color: white;
    opacity: 1;
    transition: opacity 0.6s;
    margin-bottom: 15px;
}

.alert.warning {background-color: #ff4d4d;}

.closebtn {
    margin-left: 15px;
    color: white;
    font-weight: bold;
    float: right;
    font-size: 22px;
    line-height: 20px;
    cursor: pointer;
    transition: 0.3s;
}

.closebtn:hover {
    color: black;
}

.block2-pic{
  position: relative;
}
  .hov-img0 {
  display: block;
  overflow: hidden;
}

.hov-img0 img{
  width: 100%;
  -webkit-transition: transform 0.9s ease;
  -o-transition: transform 0.9s ease;
  -moz-transition: transform 0.9s ease;
  transition: transform 0.9s ease;
}

.hov-img0:hover img {
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -ms-transform: scale(1.1);
  -o-transform: scale(1.1);
  transform: scale(1.1);
}
</style>


// WEBPACK FOOTER //
// src/components/admin-services/Gallery.vue